export default "__VITE_ASSET__B4Gpmukn__"